import { Component, Inject, Prop, Vue } from 'vue-property-decorator';
import { StripeElements, StripeElement } from 'vue-stripe-elements-plus';
import UpgradeService from './upgrade.service';

@Component({
  components: {
    StripeElements,
    StripeElement
  }
})
export default class PaymentMethod extends Vue {

  @Inject('upgradeService')
  private upgradeService: () => UpgradeService;


  @Prop({type: Boolean, default: true})
  preview: boolean;

  @Prop({type: String, default: null})
  stripeKey: string;

  @Prop({type: Object, default: null})
  stripeOptions: any;

  @Prop({type: Object, default: {}})
  elementsOptions: any;

  @Prop({type: Object,
    default: {
      // reactive
      // remember about Vue 2 reactivity limitations when dealing with options
      value: {
        postalCode: '',
      }
    }
  })
  cardOptions: Object;

  @Prop({type: Object, default: null})
  loggedUser: any;

  @Prop({type: Object, default: null})
  stripeCustomer: any;


  // @Prop({type: Boolean, default: false})
  // enterpriseToStripe: boolean;

  // @Prop({type: Boolean, default: false})
  // paymentFailed: boolean;

  public pleaseWait = false;
  public initialLoad = false;
  public stripeCustomerData = null;
  public stripeEstimates = null;
  public estimateToken = null;
  public cardInfoCompleted = false;
  public cardError = '';
  public add = false;
  public isDefaultCard = true;


  async created() {
  }

  async mounted() {
    this.pleaseWait = true;
    this.initialLoad = true;
    if (this.stripeCustomer) {
      this.stripeCustomerData = this.stripeCustomer;
    } else {
      this.stripeCustomerData = await this.upgradeService().getStripeCustomer();
    }
    this.initialLoad = false;
    this.pleaseWait = false;
  }

  public getUserDto() {
    const dto = {
      id: this.loggedUser.userId,
      email: this.loggedUser.email,
      firstName: this.loggedUser.firstName,
      lastName: this.loggedUser.lastName,
      organizationName: this.loggedUser.organizationName,
      organizationId: this.loggedUser.organizationId,
      numberOfAuthors: null,
      coupon: null,
      billingCycle: null,
      country: null,
      postalCode: null,
      token: null,
      prorationDate: null,
      subscription: null
    };
    return dto;
  }

  public async addCard() {
    this.pleaseWait = true;
    const userDto = this.getUserDto();
    if (!this.cardOnFile) {
      try {
        const data = await this.createToken();
        if (data.error) {
          this.pleaseWait = false;
          return;
        }
        userDto.token = data.token.id;
        userDto.country = data.token.card.country;
        userDto.postalCode = data.token.card.address_zip;
      } catch (e) {
        console.log('error token creation:', e);
        this.pleaseWait = false;
        return;
      }
    }
    await this.upgradeService().stripeUpdateBilling({
      email: userDto.email,
      token: this.estimateToken ? this.estimateToken.token.id : userDto.token
    });

    this.stripeCustomerData = await this.upgradeService().getStripeCustomer();

    this.add = false;
    this.preview = true;
    this.pleaseWait = false;
  }


  public async createToken() {
    const groupComponent = this.$refs.elms;
    const cardComponent = this.$refs.card;
    // Get stripe element
    const cardElement = cardComponent['stripeElement'];

    const token = await groupComponent['instance'].createToken(cardElement);

    return token;
}


  public async changeCardInput(event) {

    this.cardError = event.error != null ? event.error.message : '';
    this.cardInfoCompleted = event.complete;

    if (event.complete) {
      this.estimateToken = await this.createToken();
      if (this.estimateToken.error) {
        console.log('error token creation:', this.estimateToken.error);
        this.cardError = this.estimateToken.error.message;

      }

    } else if (this.estimateToken) {
      this.estimateToken = null;
    }

    this.$emit('changeCardInput', {cardInfoCompleted: this.cardInfoCompleted, estimateToken: this.estimateToken});
  }

  public getCardIconLink(brand) {
    if (brand) {
      switch(brand.toLowerCase()) {
        case 'visa': return '/content/images/icons/cards/visa.svg';
        case 'mastercard': return '/content/images/icons/cards/mastercard.svg';
        case 'american express' : return '/content/images/icons/cards/american-express.svg';
        case 'diners club' : return '/content/images/icons/cards/diners.svg';
        case 'discover' : return '/content/images/icons/cards/discover.png';
        case 'jcb' : return '/content/images/static/icons/cards/jbc.svg';
        case 'unionpay' : return '/content/images/static/icons/cards/unionpay.svg';
        default: return null;
      }
    }

    return null;
  }


  public get cardIcon() {
    if(this.stripeCustomerData && this.stripeCustomerData.sources.data.length && this.stripeCustomerData.sources.data[0].brand) {
      return this.getCardIconLink(this.stripeCustomerData.sources.data[0].brand);
    }

    return null;
  }

  public get noCardInfo() {
    return !(this.estimateToken || this.cardOnFile);
  }

  public get cardOnFile() {
    return !this.initialLoad && this.stripeCustomerData != null && this.stripeCustomerData.sources != null && this.stripeCustomerData.sources.data.length > 0;
  }

  public get last4Digits() {
    return this.stripeCustomerData && this.stripeCustomerData.sources.data.length && this.stripeCustomerData.sources.data[0].last4;
  }

  public get cardExpires() {
    if(this.stripeCustomerData &&
      this.stripeCustomerData.sources.data.length &&
      this.stripeCustomerData.sources.data[0].exp_month &&
      this.stripeCustomerData.sources.data[0].exp_year) {
      return this.stripeCustomerData.sources.data[0].exp_month + '/' + this.stripeCustomerData.sources.data[0].exp_year;
    }

    return null;
  }


}
